import { render } from "./Setting.vue?vue&type=template&id=60af62c8&scoped=true"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"

import "./Setting.vue?vue&type=style&index=0&id=60af62c8&lang=less&scoped=true"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.22.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60af62c8"]])

export default __exports__